import {AjaxDataTypes} from '../../../../../../../shared/AjaxDataTypes'
import {AnalyticEventCategory, AnalyticEventType} from '../../../../../../../shared/entity_datas/EntityDatas'
import {StoreItemCategory, StorePresalePackType} from '../../../../../../../shared/entity_datas/StoreEnums'
import {BaseStoreItem} from '../../../../../../../shared/store/BaseStoreItem'
import {ColonistCoinProduct} from '../../../../../../../shared/store/ColonistCoinProduct'
import {ColonistMembershipProduct} from '../../../../../../../shared/store/ColonistMembershipProduct'
import {StoreItemController} from '../../../../../../../shared/store/StoreItemController'
import {CA} from '../../../../../../shared/scripts/analytics/Analytics'
import {
    areYouSureToBuy,
    areYouSureToBuyFounderDiscount,
    doActionIfCanGiftMembership,
    doActionIfLoggedIn,
} from '../../../../../../shared/scripts/store/StoreUtils'
import {UIStoreAjaxEndPoints} from '../../../../../../shared/scripts/store/UIStoreAjaxEndPoints'
import {UIStoreBodyController} from '../../../../../../shared/scripts/store/UIStoreBodyController'
import {UIMStoreMembershipProductView} from './UIMStoreMembershipProductView'
import {UIStoreMembershipTabsController} from '../../../../../../shared/scripts/store/UIStoreMembershipTabsController'
import {UICoinProductView} from '../../../../../../shared/scripts/store/UICoinProductView'
import {UIStoreState} from '../../../../../../shared/scripts/store/UIStoreState'
import * as Item from '../../../../../../../shared/store/StoreItemList'
import {UIMStoreItemView} from './UIMStoreItemView'
import {UIMStoreSidebarController} from './UIMStoreSidebarController'
import {notificationController} from '../../../../../../shared/scripts/EntryShared'
import {UITopNotificationType} from '../../../../../../shared/scripts/notifications/UINotificationController'
import {TranslationObject} from '@colonist/i18n'
import {LocalizedPricingProductsPayload, LocalizedPricingSubscriptionsPayload, MobileWebviewCommunicationActions} from '@colonist/mobile'
import {GiftedMembershipItem} from '../../../../../../../shared/store/UserItems'
import {PaymentMethod} from '../../../../../../../shared/store/BaseColonistStoreProduct'
import {UIMMobileWebviewCommunication} from '../../../../ui_mobile_communication/UIMMobileWebviewCommunication'
import {ColonistMembershipPerkType} from '@colonist/lobby-types'
import {UIGiftedMembershipProductView} from '../../../../../../shared/scripts/store/UIGiftedMembershipProductView'
import {ClientUserState} from '../../../../../../shared/scripts/ClientUserState'
import {StorageWrapper} from '../../../../../../shared/scripts/StorageWrapper'
import {UIMStoreGiftOverlayController} from '../../../store/gift/UIStoreGiftOverlayController'
import {UIMDeviceHandler} from '../../../UIMDeviceHandler'
import {UIUtilsEjsVariables} from '../../../../../../shared/scripts/UIUtilsEjsVariables'
import {UICheckoutAjaxEndPoints} from '../../../../../../shared/scripts/ui_checkout/UICheckoutAjaxEndPoints'
import {ReferralReward} from '../../../../../../../shared/ReferralProgram'
import {setElementOnClick} from '../../../../../../shared/scripts/ui_utils/DomUtils'
import {UIMStorePopupView} from './UIMStorePopupView'
import {ReferralProgramUtils} from '../../../../../../shared/scripts/referral/ReferralProgramUtils'
import {UIStoreReferralController} from '../../../../../../shared/scripts/store/UIStoreReferralController'
import {clientI18n} from '../../../../../../shared/scripts/ClientI18n'

export class UIMStoreBodyController extends UIStoreBodyController {
    private readonly membershipsDiv: HTMLDivElement
    private readonly expansionsDiv: HTMLDivElement
    private readonly mapsDiv: HTMLDivElement
    private readonly colorsDiv: HTMLDivElement
    private readonly avatarsDiv: HTMLDivElement
    private readonly coinsDiv: HTMLDivElement
    private readonly items: UIMStoreItemView[] = []
    readonly membershipItems: UIMStoreMembershipProductView[] = []
    membershipTabsController: UIStoreMembershipTabsController

    private readonly storeState: UIStoreState
    private readonly sidebarController: UIMStoreSidebarController
    private readonly localizedStoreSubscriptionData: LocalizedPricingSubscriptionsPayload[]
    private readonly localizedStoreProductData: LocalizedPricingProductsPayload[]

    constructor(storeState: UIStoreState, sidebarController: UIMStoreSidebarController) {
        super()
        this.membershipsDiv = document.getElementById('store_page_memberships_div') as HTMLDivElement
        this.expansionsDiv = document.getElementById('store_page_expansions_div') as HTMLDivElement
        this.mapsDiv = document.getElementById('store_page_maps_div') as HTMLDivElement
        this.colorsDiv = document.getElementById('store_page_colors_div') as HTMLDivElement
        this.avatarsDiv = document.getElementById('store_page_avatars_div') as HTMLDivElement
        this.coinsDiv = document.getElementById('store_page_coins_div') as HTMLDivElement
        this.localizedStoreSubscriptionData = UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() ? StorageWrapper.getLocalizedStoreSubscriptionData() : []
        this.localizedStoreProductData = UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() ? StorageWrapper.getLocalizedStoreProductData() : []

        this.storeState = storeState
        this.sidebarController = sidebarController
        this.giftOverlayController = new UIMStoreGiftOverlayController(document.body as HTMLDivElement, this.storeState, this.localizedStoreProductData)
        this.createMembershipItems()

        this.updateAllCategoryItems()
        const coinProducts = ColonistCoinProduct.getAllCoinProducts()
        for(const product of coinProducts) {
            const localizedProductData = this.localizedStoreProductData.find((data) => data.productId == product.mobileIAPSKUId)
            new UICoinProductView(this.coinsDiv, product, () => {
                if(!ClientUserState.userState?.isLoggedIn) return
                if(UIUtilsEjsVariables.isUserOnMobileAppOrWeb) {
                    if(UIMDeviceHandler.shouldEnableNativePaymentsOnMobile() == true) {
                        UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.PurchaseProduct, {productId: product.mobileIAPSKUId, userId: ClientUserState.userState.id})
                        return
                    }
                    void UICheckoutAjaxEndPoints.executeStripeColonistProductPurchaseSession(product.storeProductType, product.type, product.itemQuantity)
                    return
                }

                UIMMobileWebviewCommunication.sendPayloadToMobile(MobileWebviewCommunicationActions.ShowTopBottomSafeArea, true)
            }, localizedProductData)
        }
    }

    private createMembershipItems() {
        this.membershipsDiv.replaceChildren()
        this.membershipItems.length = 0
        const membershipProducts = ColonistMembershipProduct.getAllMembershipProducts()
        for(const product of membershipProducts) {
            const localizedMembershipData = this.localizedStoreSubscriptionData.find((data) => data.subscriptionId === product.mobileIAPSKUId)
            const membership = new UIMStoreMembershipProductView(this.membershipsDiv, this.storeState, product, this.giftOverlayController, localizedMembershipData)
            this.membershipItems.push(membership)
        }
        this.membershipTabsController = new UIStoreMembershipTabsController(this.storeState)
    }

    protected updateAllCategoryItems() {
        this.items.length = 0
        this.updateCategoryItems(StoreItemCategory.Expansion, this.expansionsDiv)
        this.updateCategoryItems(StoreItemCategory.Map, this.mapsDiv)
        this.updateCategoryItems(StoreItemCategory.Color, this.colorsDiv)
        this.updateCategoryItems(StoreItemCategory.Icon, this.avatarsDiv)
    }

    updateCategoryItems(category: StoreItemCategory, container: HTMLDivElement) {
        container.replaceChildren()
        const itemDetails = StoreItemController.getItemsInCategory(category)
        for(const itemDetail of itemDetails) {
            const item = new UIMStoreItemView(container, itemDetail,
                () => doActionIfCanGiftMembership(() => this.giftOverlayController.show()),
                () => {
                    const eventData: AjaxDataTypes.AnalyticData = {
                        type: AnalyticEventType.StoreClickedPurchaseItem,
                        category: AnalyticEventCategory.Store,
                        floatValue: item.itemDetail.type,
                    }
                    void CA.sendAnalyticEvent(eventData)
                    CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedPurchaseItem, itemDetail.type)

                    const isBlackColor = itemDetail.name.key == new Item.SIColorBlack().name.key

                    if(!isBlackColor) {
                        const forceSubscription = ClientUserState.userState?.forceSubscription ?? true
                        const subscriptionCategory = itemDetail.category == StoreItemCategory.Expansion || itemDetail.category == StoreItemCategory.Map || itemDetail.category == StoreItemCategory.Color
                        if(forceSubscription && subscriptionCategory) {
                            this.sidebarController.openMembership()
                            return
                        }
                    }

                    doActionIfLoggedIn(() => {
                        areYouSureToBuy(itemDetail, () => {
                            CA.sendGoogleAnalyticsEvent(CA.Category.Store, CA.Label.StoreClickedApprovePurchaseItem, itemDetail.type)
                            void UIStoreAjaxEndPoints.purchaseItem(itemDetail,
                                undefined,
                                (text: TranslationObject) => notificationController.show(text, UITopNotificationType.Error))
                        },
                        () => notificationController.show({key: 'strings:storePage.message.notEnoughCoins'},
                            UITopNotificationType.Error,
                            {key: 'strings:storePage.coins.buyCoins'},
                            () => this.sidebarController.openCoins()))
                    })
                })
            this.items.push(item)
        }
    }

    updateOwnedItems(ownedItems: BaseStoreItem[]) {
        this.updateAllCategoryItems()
        void this.updateReferralProgram()
        for(const ownedItem of ownedItems) {
            for(const itemView of this.items) {
                if(itemView.itemDetail.name.key == ownedItem.name.key) {
                    itemView.markAsOwned()
                    break
                }
            }
        }
    }

    updateSubscribedItems(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined) {
        if(ownedMembership == undefined) return
        for(const perk of ownedMembership.perks) {
            if(perk.type == ColonistMembershipPerkType.AllColors) {
                this.markItemsAsSubscribed(StoreItemCategory.Color)
            }
            if(perk.type == ColonistMembershipPerkType.AllMaps) {
                this.markItemsAsSubscribed(StoreItemCategory.Map)
            }
            if(perk.type == ColonistMembershipPerkType.AllExpansions) {
                this.markItemsAsSubscribed(StoreItemCategory.Expansion)
            }
        }
    }

    private markItemsAsSubscribed(category: StoreItemCategory) {
        for(const itemView of this.items) {
            if(itemView.itemDetail.category != category) continue
            itemView.markAsSubscribed()
        }
    }

    updateOwnedMembership(ownedMembership: ColonistMembershipProduct | undefined, paymentMethod: PaymentMethod | undefined) {
        this.createMembershipItems()
        if(ownedMembership == undefined) return

        let makeUpgrade = false

        const disableMembershipManagement = this.shouldDisableMembershipManagement(paymentMethod)
        const iOwnAnnualMembership = ColonistMembershipProduct.isAnnualMembership(ownedMembership.type)
        for(const membershipView of this.membershipItems) {
            if(disableMembershipManagement) {
                if(membershipView.membershipProduct.type == ownedMembership.type) {
                    const isGift = paymentMethod === PaymentMethod.None
                    if(isGift) {
                        membershipView.changeToCancelButton()
                    } else {
                        membershipView.changeToOwnedButton()
                    }
                    continue
                }
                membershipView.removeButton()
                continue
            }

            if(!iOwnAnnualMembership && ColonistMembershipProduct.isAnnualMembership(membershipView.membershipProduct.type)) {
                membershipView.changeToGoAnnualButton()
                continue
            }
            if(makeUpgrade) {
                membershipView.changeToUpgradeButton()
                continue
            }
            if(membershipView.membershipProduct.type == ownedMembership.type) {
                membershipView.changeToManageButton()
                makeUpgrade = true
                continue
            }
            membershipView.changeToDowngradeButton()
        }
    }

    updatePriceForFounderPack(ownedItems: BaseStoreItem[]) {
        const hasFounderPack = UIMStoreBodyController.hasFounderPack(ownedItems)
        if(!hasFounderPack) return
        for(const itemView of this.items) {
            if(itemView.isMarkedOwned) continue
            if(itemView.itemDetail.category != StoreItemCategory.Expansion && itemView.itemDetail.category != StoreItemCategory.Map) continue
            itemView.makePrice0()
            itemView.updateAction(() => {
                areYouSureToBuyFounderDiscount(itemView.itemDetail, () => {
                    void UIStoreAjaxEndPoints.purchaseItem(itemView.itemDetail,
                        (text: TranslationObject) => notificationController.show(text, UITopNotificationType.Success),
                        (text: TranslationObject) => notificationController.show(text, UITopNotificationType.Error))
                })
            })
        }
    }

    private static hasFounderPack(ownedItems: BaseStoreItem[]): boolean {
        for(const item of ownedItems) {
            if(item.category != StoreItemCategory.PresalePack) continue
            if(item.type != StorePresalePackType.FounderPack) continue
            return true
        }
        return false
    }

    updateGiftedMemberships(memberships: GiftedMembershipItem[]) {
        const grid = document.getElementById('store_page_gifted_memberships_div') as HTMLDivElement
        if(grid == undefined) return

        grid.replaceChildren()
        document.getElementById('gifted_memberships')?.classList.toggle('hidden', memberships.length == 0)

        for(const membership of memberships) {
            const localizedGiftMembership = this.localizedStoreProductData.find((data) => data.productId == membership.id)
            new UIGiftedMembershipProductView(grid, this.storeState, membership, async(id) => {
                await UIStoreAjaxEndPoints.activateGiftedMembership(id)
            }, localizedGiftMembership)
        }
    }

    // eslint-disable-next-line class-methods-use-this
    async onInviteFriendsButtonClick(referralReward: ReferralReward, userReferralCount: number) {
        const link = await ReferralProgramUtils.getReferralLinkForSharing()
        UIMDeviceHandler.sendShareLink(link, clientI18n.t('strings:storePage.sections.referral.mobileCTA'))

        const eventData: AjaxDataTypes.AnalyticData = {
            type: AnalyticEventType.ReferralAnalytics,
            category: AnalyticEventCategory.MobileStoreReferralProgramReferFriends,
            floatValue: referralReward.analyticsPopupTriggered,
        }
        void CA.sendAnalyticEvent(eventData)
    }

    // eslint-disable-next-line class-methods-use-this
    override setupReferralRewardClickHandler(contentDiv: HTMLDivElement, description: HTMLParagraphElement, image: HTMLImageElement, referralReward: ReferralReward) {
        setElementOnClick(contentDiv, () => {
            new UIMStorePopupView(referralReward.name, referralReward.image, {key: 'strings:colonistCommon.utils.#buffer', options: {value: UIStoreReferralController.loadReferralItemDescription(referralReward)}})
        })
    }

    onStoreViewVisible() {
        void this.updateReferralProgram()
    }
}
